module.exports = __webpack_public_path__ + "images/firefox.jpg?33000a6473d7333f093d146fc6af3a08";